import { useLocation } from 'react-router'

export default function useQuery(key) {
  return new URLSearchParams(useLocation().search).get(key)
}
